export default "__VITE_ASSET__17b522a5__"